module.exports = __webpack_public_path__ + "img/swap-color.5c52a7af.svg";